
import { useMemo } from "react";

export function useMeanIdeaRating(items) {
  return useMemo(() => {
    const nums = items
      .map((x) => (typeof x.ideaRating === "string" ? Number(x.ideaRating) : x.ideaRating))
      .filter((x) => typeof x === "number" && !Number.isNaN(x));

      const countGivenRating = items.filter((x) => {
        const v = x?.ideaRating;
        // Accept numbers or non-empty strings (e.g., '20'); reject '', null, undefined
        if (typeof v === 'number') return true;
        if (typeof v === 'string') return v.trim() !== '';
        return false;
      })?.length;
      
    if (nums.length === 0) return { mean: 0, count: 0 };
    if (countGivenRating === 0) return { mean: 0, count: 0 };
    const sum = nums.reduce((acc, v) => acc + v, 0);
    return { mean: sum / countGivenRating, countAvaiableRating:countGivenRating ,totalCount: nums.length };
  }, [items]);
}
